module.exports = __webpack_public_path__ + "img/instagram.bb447ea6.svg";